// src/translations/pages/impressum/nl.js
import { injectPersonalData } from './impressumUtils.js';

const baseTranslationNL = {
  title: 'Colofon',
  subtitle: 'Gegevens volgens § 5 DDG (Duitse wet inzake digitale diensten)',
  
  serviceProvider: 'Dienstaanbieder',
  
  contactTitle: 'Contact',
  addressLabel: 'Adres',
  contactLabel: 'E-mailadres',
  
  professionalTitle: 'Bedrijfsgegevens',
  professionLabel: 'Rechtsvorm',
  businessTypeLabel: 'Aard van de activiteiten',
  
  taxTitle: 'Fiscale gegevens',
  
  liabilityTitle: 'Aansprakelijkheid',
  contentLiabilityTitle: 'Aansprakelijkheid voor inhoud',
  contentLiability: 'Als dienstaanbieder zijn wij op grond van § 7 lid 1 DDG volgens de algemene wetgeving verantwoordelijk voor de eigen inhoud op deze pagina\'s. Op grond van §§ 8 tot en met 10 DDG zijn wij als dienstaanbieder echter niet verplicht om doorgegeven of opgeslagen informatie van derden te controleren of onderzoek te doen naar omstandigheden die op een onrechtmatige activiteit wijzen.',
  
  linkLiabilityTitle: 'Aansprakelijkheid voor links',
  linkLiability: 'Ons aanbod bevat links naar externe websites van derden, op de inhoud waarvan wij geen invloed hebben. Daarom kunnen wij voor deze externe inhoud geen garantie geven. Voor de inhoud van de gelinkte pagina\'s is altijd de betreffende aanbieder of beheerder van die pagina\'s verantwoordelijk. De gelinkte pagina\'s zijn op het moment waarop de link werd geplaatst gecontroleerd op mogelijke rechtsschendingen. Onrechtmatige inhoud was op dat moment niet herkenbaar.',
  
  copyrightTitle: 'Auteursrecht',
  copyright: 'De inhoud en de werken die de beheerders van deze pagina\'s hebben gemaakt, vallen onder het Duitse auteursrecht. Voor verveelvoudiging, bewerking, verspreiding en elke vorm van exploitatie buiten de grenzen van het auteursrecht is schriftelijke toestemming van de betreffende auteur of maker vereist. Downloads en kopieën van deze pagina zijn alleen toegestaan voor privégebruik, niet voor commercieel gebruik.'
};

// Export the translation with injected personal data
export const impressumPageNL = injectPersonalData('nl', baseTranslationNL);